import { BRAND_COLLECTION } from '../utils/constDictionary'

/**
 * transformLayout rearranges the layouts based on the FE requirements
 * It is not intended to change the order of the layouts, but we can change
 * the order of collections for some specific layouts like BrandCollection
 * @param {Array} layouts
 * @param {Array} layoutNames
 * @return {Array} rearranged layouts
 */
function transformLayout(layouts, layoutNames = []) {
  if (!layouts || !layoutNames.length) {
    return layouts
  }

  return layouts.map(layout => {
    const { data, name, value } = layout
    if (!layoutNames.includes(name)) {
      return layout
    }

    if (name === BRAND_COLLECTION) {
      const { brandIds } = data
      const sortedCollection = value.collection
        ? [...value.collection].sort(({ brand: brandA }, { brand: brandB }) => {
            return brandIds.indexOf(brandA.id) - brandIds.indexOf(brandB.id)
          })
        : []

      return { ...layout, value: { ...value, collection: sortedCollection } }
    }

    return { ...layout, value }
  })
}

export default transformLayout
